import React from 'react';
import type { ValidationError } from '@wix/form-validator';
import { type FieldLayoutComponent } from '../../../../field-layout';
import {
  type FormValues,
  isInputField,
  type OnFieldChange,
  isNestedFormField,
  type Field,
} from '../../types';
import { InputField } from './input-field';
import { ReadOnlyField } from './read-only-field';
import { NestedFormField } from './nested-form-field';
import { SubmitButtonField } from './submit-button-field';
import { isMultilineAddressField } from '../../../../services/multiline-address';

interface FormFieldProps {
  field: Field;
  values: FormValues;
  errors: ValidationError[];
  onFieldChange?: OnFieldChange;
  FieldLayout: FieldLayoutComponent;
}

export const FormField = ({ field, FieldLayout, ...rest }: FormFieldProps) => {
  if (!isMultilineAddressField(field) && isNestedFormField(field)) {
    return (
      <NestedFormField {...rest} field={field} FieldLayout={FieldLayout} />
    );
  }

  if (isInputField(field)) {
    return <InputField {...rest} field={field} FieldLayout={FieldLayout} />;
  }

  if (field.fieldType === 'SUBMIT_BUTTON') {
    return (
      <SubmitButtonField {...rest} field={field} FieldLayout={FieldLayout} />
    );
  }

  return <ReadOnlyField {...rest} field={field} FieldLayout={FieldLayout} />;
};
